import "antd/es/breadcrumb/style";
import _Breadcrumb from "antd/es/breadcrumb";
var _excluded = ["children", "routes", "itemRender", "showEllipsis", "className", "maxItemLength", "headItemLength", "tailItemLength"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import React, { useReducer } from 'react';
import classNames from 'classnames';
import './index.less';
var clsPrefix = 'osui-breadcrumb';

var Ellipsis = function Ellipsis(_ref) {
  var onClick = _ref.onClick;
  return /*#__PURE__*/React.createElement("span", {
    className: "".concat(clsPrefix, "-ellipsis"),
    onClick: onClick
  }, "...");
};

var getItemRenderWithEllipsis = function getItemRenderWithEllipsis(render, config) {
  return function (route, params, routes, paths) {
    var shownLastItems = config.shownLastItems,
        onEllipsisClick = config.onEllipsisClick,
        headItemLength = config.headItemLength;
    var index = routes.indexOf(route); // 当展示前两个item 且 总长度 - 展示出来后n个 > 2 时，展示 ...

    if (index === headItemLength && routes.length - shownLastItems > headItemLength) {
      return /*#__PURE__*/React.createElement(Ellipsis, {
        onClick: onEllipsisClick
      });
    } // 隐藏掉 2 到 展示出来后n个之间的 item


    if (index > headItemLength && index < routes.length - shownLastItems) {
      return null;
    }

    return render && render(route, params, routes, paths);
  };
};

var getChildrenWithEllipsis = function getChildrenWithEllipsis(children, config) {
  var shownLastItems = config.shownLastItems,
      onEllipsisClick = config.onEllipsisClick,
      maxItemLength = config.maxItemLength,
      headItemLength = config.headItemLength; // 如果不是array，或者children长度小于maxItemLenght时，直接展示children

  if (!Array.isArray(children) || children.length <= maxItemLength) {
    return children;
  } // 如果剩余最后两个item没展示时，去掉Ellipsis，展示所有


  if (children.length - shownLastItems <= headItemLength) {
    return children;
  } // 展示 第一个，第二个， ... 倒数两个


  return [].concat(_toConsumableArray(children.slice(0, headItemLength)), [/*#__PURE__*/React.createElement(_Breadcrumb.Item, {
    key: "_ellipsis"
  }, /*#__PURE__*/React.createElement(Ellipsis, {
    onClick: onEllipsisClick
  }))], _toConsumableArray(children.slice(-shownLastItems)));
};

var Breadcrumb = function Breadcrumb(props) {
  var children = props.children,
      routes = props.routes,
      itemRender = props.itemRender,
      showEllipsis = props.showEllipsis,
      className = props.className,
      _props$maxItemLength = props.maxItemLength,
      maxItemLength = _props$maxItemLength === void 0 ? 5 : _props$maxItemLength,
      _props$headItemLength = props.headItemLength,
      headItemLength = _props$headItemLength === void 0 ? 2 : _props$headItemLength,
      _props$tailItemLength = props.tailItemLength,
      tailItemLength = _props$tailItemLength === void 0 ? 2 : _props$tailItemLength,
      restProps = _objectWithoutProperties(props, _excluded);

  var _useReducer = useReducer(function (index) {
    // step
    if (children && Array.isArray(children) && children.length - index > 1) {
      return index + 1;
    }

    if (routes && routes.length - index > 1) {
      return index + 1;
    }

    return 0;
  }, tailItemLength),
      _useReducer2 = _slicedToArray(_useReducer, 2),
      shownLastItems = _useReducer2[0],
      doPop = _useReducer2[1];

  var isShowEllipsis = showEllipsis && (routes && routes.length > maxItemLength || children && Array.isArray(children) && children.length > maxItemLength);
  var config = {
    shownLastItems: shownLastItems,
    onEllipsisClick: doPop,
    maxItemLength: maxItemLength,
    headItemLength: headItemLength,
    tailItemLength: tailItemLength
  };
  return /*#__PURE__*/React.createElement(_Breadcrumb, _objectSpread({
    className: classNames(clsPrefix, className),
    itemRender: isShowEllipsis && itemRender ? getItemRenderWithEllipsis(itemRender, config) : itemRender,
    routes: routes
  }, restProps), isShowEllipsis && children ? getChildrenWithEllipsis(children, config) : children);
};

Breadcrumb.Item = _Breadcrumb.Item;
Breadcrumb.Separator = _Breadcrumb.Separator;
export default Breadcrumb;
//# sourceMappingURL=index.js.map